import React, { useState, useEffect } from 'react';

function App() {
  const [profiles, setProfiles] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  // ⚠️ សូមដាក់ Web App URL របស់អ្នកនៅទីនេះ
  const API_URL = 'https://script.google.com/macros/s/AKfycby0yFUjm1arfiQguq-jFeOAHWRO8j4S6DbeaB1tyadY7N43i_NagiLoNpevTK0ZjVU4/exec'; 
  
  // ⚠️ សូមដាក់ Link Logo របស់អ្នកនៅទីនេះ (នេះជារូបតំណាងបណ្ដោះអាសន្ន)
  const LOGO_URL = './Logo.png';

  useEffect(() => {
    fetch(API_URL)
      .then(response => response.json())
      .then(data => {
        if(data.status === 'success') {
          setProfiles(data.data);
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Error:', error);
        setLoading(false);
      });
  }, []);

  const hasSearchText = search.trim().length > 0;

  const filteredProfiles = hasSearchText 
    ? profiles.filter(profile => 
        profile.name.toLowerCase().includes(search.toLowerCase()) || 
        profile.team.toLowerCase().includes(search.toLowerCase())
      )
    : [];

  const clearSearch = () => {
    setSearch('');
  };

  return (
    <div className="min-h-screen bg-[#F4F6F9] font-sans pb-10 selection:bg-[#4F6BFF] selection:text-white">
      
      {/* ផ្នែក Header ដែលមាន Logo */}
      <div className="pt-10 px-6 max-w-md mx-auto text-center animate-fade-in-down">
        
        {/* បង្ហាញ Logo នៅទីនេះ */}
        <div className="flex justify-center mb-4">
          <img 
            src={LOGO_URL} 
            alt="DI Logo" 
            className="w-20 h-20 object-contain drop-shadow-md animate-bounce-slow"
          />
        </div>

        <h1 className="text-3xl font-extrabold text-[#4F6BFF] leading-snug mb-2 tracking-tight">
          Digital Industry
        </h1>
        <p className="text-gray-500 text-sm mb-8 font-medium">
          ស្វែងរកព័ត៌មានក្រុមការងារយ៉ាងងាយស្រួល
        </p>
        
        {/* Search Bar */}
        <div className="relative mb-8 group transition-all duration-300 transform hover:scale-[1.02]">
          <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
            <svg className="h-5 w-5 text-gray-400 group-focus-within:text-[#4F6BFF] transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <input
            type="text"
            className="w-full pl-11 pr-12 py-4 bg-white border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#4F6BFF] shadow-sm text-gray-700 text-lg transition-all"
            placeholder="វាយឈ្មោះ ឬក្រុមការងារ..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {hasSearchText && (
            <button 
              onClick={clearSearch}
              className="absolute inset-y-0 right-4 flex items-center text-gray-400 hover:text-red-500 transition-colors focus:outline-none"
            >
              <svg className="h-5 w-5 bg-gray-100 rounded-full p-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </div>

      {/* ផ្នែកបង្ហាញលទ្ធផល */}
      <div className="px-5 max-w-md mx-auto">
        {loading ? (
          <div className="flex flex-col items-center justify-center py-16 space-y-4">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-[#4F6BFF]"></div>
            <p className="text-gray-400 text-sm animate-pulse">កំពុងរៀបចំទិន្នន័យ...</p>
          </div>
        ) : !hasSearchText ? (
          <div className="text-center py-16 bg-white rounded-3xl border border-gray-100 shadow-sm transition-all animate-fade-in">
            <div className="text-6xl mb-4">👋</div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">ស្វាគមន៍មកកាន់ប្រព័ន្ធ!</h3>
            <p className="text-gray-500 text-sm px-8">
              សូមវាយបញ្ចូលឈ្មោះ ឬក្រុមការងារ នៅក្នុងប្រអប់ខាងលើដើម្បីចាប់ផ្ដើមស្វែងរក។
            </p>
          </div>
        ) : filteredProfiles.length > 0 ? (
          <div className="space-y-8 pb-8">
            <div className="text-sm text-gray-500 text-right pr-2">
              រកឃើញ: <span className="font-bold text-[#4F6BFF]">{filteredProfiles.length}</span> នាក់
            </div>
            {filteredProfiles.map((profile, index) => (
              <div key={index} className="bg-white rounded-3xl shadow-sm overflow-visible relative mt-8 border border-gray-100 transition-all duration-500 hover:shadow-xl transform hover:-translate-y-1 animate-fade-in-up">
                
                <div className="h-24 bg-gradient-to-r from-[#4F6BFF] to-[#7187FF] rounded-t-3xl relative overflow-hidden">
                  <div className="absolute opacity-20 -right-4 -top-4 w-24 h-24 rounded-full border-4 border-white"></div>
                  <div className="absolute opacity-20 -left-6 top-8 w-16 h-16 rounded-full border-4 border-white"></div>
                </div>
                
                <div className="absolute top-8 left-1/2 transform -translate-x-1/2">
                  <div className="relative">
                    <img 
                      src={profile.image} 
                      alt={profile.name} 
                      className="w-24 h-24 object-cover rounded-full border-[4px] border-white bg-gray-50 shadow-md"
                      onError={(e)=>{e.target.src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"}} 
                    />
                    <span className="absolute bottom-1 right-1 w-4 h-4 bg-green-400 border-2 border-white rounded-full"></span>
                  </div>
                </div>
                
                <div className="pt-14 pb-6 px-6">
                  <div className="text-center mb-6">
                    <h2 className="text-xl font-extrabold text-gray-800">{profile.name}</h2>
                    <span className="inline-block mt-2 px-4 py-1.5 bg-[#F0F4FF] text-[#4F6BFF] text-xs font-bold rounded-full border border-[#DCE4FF]">
                      {profile.team || 'DI Support'}
                    </span>
                  </div>
                  
                  <div className="space-y-3 bg-gray-50 p-4 rounded-2xl text-sm border border-gray-100">
                    <div className="flex justify-between items-center border-b border-gray-200 pb-2">
                      <span className="text-gray-500 flex items-center gap-2">
                        <span>👤</span> ភេទ
                      </span>
                      <span className="font-semibold text-gray-800">{profile.gender}</span>
                    </div>
                    <div className="flex justify-between items-center border-b border-gray-200 pb-2">
                      <span className="text-gray-500 flex items-center gap-2">
                        <span>🏫</span> ថ្នាក់រៀន
                      </span>
                      <span className="font-semibold text-gray-800">{profile.classLevel}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-500 flex items-center gap-2">
                        <span>🎓</span> ជំនាន់
                      </span>
                      <span className="font-semibold text-gray-800">{profile.generation}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 bg-white rounded-3xl border border-gray-100 shadow-sm animate-fade-in">
            <div className="text-5xl mb-4">🕵️‍♂️</div>
            <h3 className="text-lg font-bold text-gray-800 mb-1">រកមិនឃើញទិន្នន័យទេ</h3>
            <p className="text-gray-500 text-sm">
              សមាជិកឈ្មោះ <b>"{search}"</b> មិនមានក្នុងប្រព័ន្ធឡើយ។
            </p>
          </div>
        )}
      </div>

      <style>{`
        .animate-fade-in { animation: fadeIn 0.5s ease-out; }
        .animate-fade-in-down { animation: fadeInDown 0.6s ease-out; }
        .animate-fade-in-up { animation: fadeInUp 0.5s ease-out; }
        .animate-bounce-slow { animation: bounceSlow 3s infinite; }
        
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes fadeInDown { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes bounceSlow { 
          0%, 100% { transform: translateY(0); } 
          50% { transform: translateY(-8px); } 
        }
      `}</style>

    </div>
  );
}

export default App;